import { PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '../../../shared/ui/button';
import { CreateWorkspaceDialog } from './ui';

/** "New workspace" as a page action: opens the dialog and goes to the workspace it creates. */
export function CreateWorkspaceButton({ org }: { org: { id: string; slug: string } }) {
  const { t } = useTranslation('workspace');
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <PlusIcon aria-hidden="true" />
        {t('nav.new')}
      </Button>
      <CreateWorkspaceDialog
        org={org}
        open={open}
        onOpenChange={setOpen}
        onCreated={(workspace) => navigate(`/o/${org.slug}/w/${workspace.slug}`)}
      />
    </>
  );
}
